import { axiosApi } from '@/axios'
import { createOrUpdateJSON } from '@/utils/functions'
import { Paginator, Params } from '@/utils/interfaces'
import {
  BuySmsProduct,
  PurchasedProduct,
  SmsTag,
} from '@/utils/interfaces/sms.interface'
import { Dictionary } from 'vue-router/types/router'

export const getSms = (params?: Params) =>
  axiosApi.get('/topups/messages/list/', { params })

/**
 * Sends a sms to a group of clients and tags
 * @param body sms body create content
 */
export const sendSms = (body: object) =>
  axiosApi.post('/topups/messages/list/', body)

export const createOrUpdateClient = (body: Dictionary<string>) =>
  createOrUpdateJSON('/topups/messages/clients/', body)

export const getSmsClients = (params?: Params) =>
  axiosApi.get('/topups/messages/clients/', { params })

export const buySmsProduct = (body: BuySmsProduct) =>
  axiosApi.post('/topups/products/buy/', body)

export const getSmsPurchasedProducts = (params?: Params) =>
  axiosApi.get<Paginator<PurchasedProduct>>('/topups/products/purchased/', {
    params,
  })

export const getSmsTags = (params?: Params) =>
  axiosApi.get<Paginator<SmsTag>>('/topups/messages/tags/', { params })

export const creteOrUpdateSmsTag = (body: { name: string }) =>
  createOrUpdateJSON('/topups/messages/tags/', body)
